import React from 'react'

const MenuSection = ({menuData}) => {
  return (
    <React.Fragment>
      <div className="flex w-full items-center Xlg:border-b Xlg:border-wt-blue-gray Xlg:border-opacity-50 mt-4 mb-1">
        {/* <span className="hidden lg:block icon">
          <i className={`text-wt-blue-gray pr-2 ${menuData.iconDef}`}></i>
        </span> */}
        <span className="text-lg lg:text-xl font-display font-light text-wt-blue-gray XXpl-4">{menuData.title}</span>
      </div>
      <div className="flex flex-col w-full border-l-2 border-wt-blue-gray border-opacity-20 pl-1">
        {
          menuData.links.map((menuItem, index) => {
            return (
              <a className="py-1 px-2 text-gray-200 text-sm lg:text-base rounded hover:bg-opacity-20 hover:bg-white hover:text-wt-blue-highlight" href={ menuItem.linkURL } key={index}>
                { menuItem.linkTitle }
              </a>
            )
          })
        }
      </div>
    </React.Fragment>
  )
}

export default MenuSection;